function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  stroke: "#885DF0",
  strokeWidth: 2.053
}), /*#__PURE__*/React.createElement("g", {
  fill: "#5933B4",
  stroke: "#885DF0",
  strokeWidth: 0.979
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.991 34.979c.422 0 .764-.24.764-.534 0-.294-.342-.533-.764-.533h-6.964c-.422 0-.764.239-.764.533 0 .295.342.534.764.534h6.964zM22.727 12.267c-2.751 0-5.052 2.017-5.52 4.668a4.852 4.852 0 0 0-4.407 4.846c0 2.698 2.166 4.886 4.836 4.886H28.8v-.882l-11.164-.147c-2.124 0-3.818-1.711-3.818-3.857s1.694-3.857 3.818-3.857a.511.511 0 0 0 .51-.466c.23-2.335 2.201-4.163 4.581-4.163 1.296 0 2.356.507 3.198 1.382a.505.505 0 0 0 .549.12c.367-.14.891-.216 1.344-.216a3.584 3.584 0 0 1 3.564 3.142c.022.195.151.36.334.426 1.455.54 2.466 1.953 2.466 3.632 0 2.146-1.694 3.857-3.818 3.857l-1.564.147v.882h1.564c2.67 0 4.836-2.188 4.836-4.886a4.854 4.854 0 0 0-2.856-4.444 4.612 4.612 0 0 0-4.526-3.785c-.461 0-.946.077-1.4.21-.98-.918-2.235-1.495-3.69-1.495zM17.583 30.492c0 .295.342.533.764.533h12.325c.421 0 .763-.238.763-.533 0-.295-.342-.533-.763-.533H18.347c-.422 0-.764.238-.764.533z"
})));

const SvgIcCvs = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCvs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-cvs.ab4dd591.svg";
export { ForwardRef as ReactComponent };